import React from 'react';

function IntroIglTitle () {
    return(
        <div>
            <h1 className="GuideTitle">Introduction</h1>
            <h2 className="GuideTitleH2">Written By: David "Gatr" Macaulay</h2>
        </div>
    )
}

export default IntroIglTitle;